export default "__VITE_ASSET__CjtVMIV8__"